/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
  "data": {
    "day": {
      "-1": "Àná",
      "-2": "íjɛta",
      "0": "Òní",
      "1": "Ɔ̀la",
      "2": "òtúùnla",
      "future": {
        "other": "+{0} d"
      },
      "past": {
        "other": "-{0} d"
      }
    },
    "day-narrow": {
      "-1": "Àná",
      "-2": "íjɛta",
      "0": "Òní",
      "1": "Ɔ̀la",
      "2": "òtúùnla",
      "future": {
        "other": "+{0} d"
      },
      "past": {
        "other": "-{0} d"
      }
    },
    "day-short": {
      "-1": "Àná",
      "-2": "íjɛta",
      "0": "Òní",
      "1": "Ɔ̀la",
      "2": "òtúùnla",
      "future": {
        "other": "+{0} d"
      },
      "past": {
        "other": "-{0} d"
      }
    },
    "hour": {
      "0": "wákàtí yìí",
      "future": {
        "other": "+{0} h"
      },
      "past": {
        "other": "-{0} h"
      }
    },
    "hour-narrow": {
      "0": "wákàtí yìí",
      "future": {
        "other": "+{0} h"
      },
      "past": {
        "other": "-{0} h"
      }
    },
    "hour-short": {
      "0": "wákàtí yìí",
      "future": {
        "other": "+{0} h"
      },
      "past": {
        "other": "-{0} h"
      }
    },
    "minute": {
      "0": "ìshɛ́jú yìí",
      "future": {
        "other": "+{0} min"
      },
      "past": {
        "other": "-{0} min"
      }
    },
    "minute-narrow": {
      "0": "ìshɛ́jú yìí",
      "future": {
        "other": "+{0} min"
      },
      "past": {
        "other": "-{0} min"
      }
    },
    "minute-short": {
      "0": "ìshɛ́jú yìí",
      "future": {
        "other": "+{0} min"
      },
      "past": {
        "other": "-{0} min"
      }
    },
    "month": {
      "-1": "óshù tó kɔjá",
      "0": "oshù yìí",
      "1": "óshù tó ń bɔ̀,",
      "future": {
        "other": "+{0} m"
      },
      "past": {
        "other": "-{0} m"
      }
    },
    "month-narrow": {
      "-1": "óshù tó kɔjá",
      "0": "oshù yìí",
      "1": "óshù tó ń bɔ̀,",
      "future": {
        "other": "+{0} m"
      },
      "past": {
        "other": "-{0} m"
      }
    },
    "month-short": {
      "-1": "óshù tó kɔjá",
      "0": "oshù yìí",
      "1": "óshù tó ń bɔ̀,",
      "future": {
        "other": "+{0} m"
      },
      "past": {
        "other": "-{0} m"
      }
    },
    "nu": [
      "latn"
    ],
    "quarter": {
      "-1": "last quarter",
      "0": "this quarter",
      "1": "next quarter",
      "future": {
        "other": "+{0} Q"
      },
      "past": {
        "other": "-{0} Q"
      }
    },
    "quarter-narrow": {
      "-1": "last quarter",
      "0": "this quarter",
      "1": "next quarter",
      "future": {
        "other": "+{0} Q"
      },
      "past": {
        "other": "-{0} Q"
      }
    },
    "quarter-short": {
      "-1": "last quarter",
      "0": "this quarter",
      "1": "next quarter",
      "future": {
        "other": "+{0} Q"
      },
      "past": {
        "other": "-{0} Q"
      }
    },
    "second": {
      "0": "nísinsìyí",
      "future": {
        "other": "+{0} s"
      },
      "past": {
        "other": "-{0} s"
      }
    },
    "second-narrow": {
      "0": "nísinsìyí",
      "future": {
        "other": "+{0} s"
      },
      "past": {
        "other": "-{0} s"
      }
    },
    "second-short": {
      "0": "nísinsìyí",
      "future": {
        "other": "+{0} s"
      },
      "past": {
        "other": "-{0} s"
      }
    },
    "week": {
      "-1": "ɔ̀sɛ̀ tó kɔjá",
      "0": "ɔ̀sɛ̀ yìí",
      "1": "ɔ́sɛ̀ tó ń bɔ̀",
      "future": {
        "other": "+{0} w"
      },
      "past": {
        "other": "-{0} w"
      }
    },
    "week-narrow": {
      "-1": "ɔ̀sɛ̀ tó kɔjá",
      "0": "ɔ̀sɛ̀ yìí",
      "1": "ɔ́sɛ̀ tó ń bɔ̀",
      "future": {
        "other": "+{0} w"
      },
      "past": {
        "other": "-{0} w"
      }
    },
    "week-short": {
      "-1": "ɔ̀sɛ̀ tó kɔjá",
      "0": "ɔ̀sɛ̀ yìí",
      "1": "ɔ́sɛ̀ tó ń bɔ̀",
      "future": {
        "other": "+{0} w"
      },
      "past": {
        "other": "-{0} w"
      }
    },
    "year": {
      "-1": "Èshí",
      "0": "Ɔdún yìí",
      "1": "Àmɔ́dún",
      "future": {
        "other": "ní {0} Ɔdún"
      },
      "past": {
        "other": "{0} Ɔdún sɛ́yìn"
      }
    },
    "year-narrow": {
      "-1": "Ɔdún tó kɔjá",
      "0": "Ɔdún yìí",
      "1": "Ɔdún tó ńbɔ̀",
      "future": {
        "other": "ní {0} Ɔdún"
      },
      "past": {
        "other": "Ɔdún {0} sɛ́yìn"
      }
    },
    "year-short": {
      "-1": "Ɔdún tó kɔjá",
      "0": "Ɔdún yìí",
      "1": "Ɔdún tó ńbɔ̀",
      "future": {
        "other": "ní {0} Ɔdún"
      },
      "past": {
        "other": "Ɔdún {0} sɛ́yìn"
      }
    }
  },
  "locale": "yo-BJ"
})
}
